module.exports = __webpack_public_path__ + "img/i_plans.fc0e7725.svg";